<template>

  <div>
    <v-data-table :headers="headers"
                  :items="items"
                  :pagination.sync="pagination_"
                  :total-items="totalItems"
                  :rows-per-page-items="paginationOptions"
                  :loading="loading">
      <v-progress-linear slot="progress"
                         color="primary"
                         indeterminate="indeterminate"></v-progress-linear>
      <template slot="items" slot-scope="props" v-show="!loading">

        <!-- ID -->
        <td :class="$vuetify.breakpoint.name">
          <ExternalId :id="props.item.id" :path="'/clip/' + props.item.id" />
        </td>

        <!-- SPORT -->
        <td :class="$vuetify.breakpoint.name">
          <v-tooltip bottom :disabled="props.item.sportIDs &&props.item.sportIDs.length < 3">
            <template v-slot:activator="{ on }">
              <span v-on="on" class="text-no-wrap">{{ displaySportNames(props.item.sportIDs) }}</span>
            </template>
            <span>{{ props.item.sportIDs ? props.item.sportIDs.map(sportID => getSportName(sportID)).join(', ') : '' }}</span>
          </v-tooltip>
        </td>

        <!-- DATE -->
        <td :class="$vuetify.breakpoint.name">{{ formatDate(props.item.publishDate) }}</td>

        <!-- TITLE -->
        <td class="wide-column" :class="$vuetify.breakpoint.name"><b>{{ props.item.title }}</b></td>

        <!-- CAPTION -->
        <td class="wide-column" :class="$vuetify.breakpoint.name">{{ props.item.caption }}</td>

        <!-- CLUBS -->
        <td :class="$vuetify.breakpoint.name">
          <div class="clubs-container">
            <div class="club-count"
                 v-if="props.item.clubs"
                 @mouseover="clubHover(props.item.id)"
                 @mouseout="clubBlur(props.item.id)">{{ props.item.clubs.length || 0 }}</div>
            <div class="club-count"
            v-if="!props.item.clubs">0</div>
            <div class="clubs" v-if="clubsDisplayed(props.item.id)">
              <div class="club-container" v-for="club in props.item.clubs" :key="club.id">
                <div class="club-logo-container" :class="club.isPrimary ? 'primary-club' : ''">
                  <img class="club-logo-img" v-if="!club.logoUrl" src="../../../static/icons/club-icon-256x256-darkblue.png"/>
                  <img class="club-logo-img" v-if="club.logoUrl" :src="club.logoUrl"/>
                </div>
                <p class="club-name" :class="club.isPrimary ? 'primary-club' : ''">{{ club.alias.toUpperCase() }}</p>
              </div>
            </div>
          </div>
        </td>

        <!-- TEAMS -->
        <td :class="$vuetify.breakpoint.name" v-if="$country === 'US'">
          <div class="clubs-container">
            <div class="club-count"
                 v-if="props.item.teams"
                 @mouseover="teamHover(props.item.id)"
                 @mouseout="teamBlur(props.item.id)">{{ props.item.teams.length || 0 }}</div>
            <div class="club-count"
                 v-if="!props.item.teams">0</div>
            <div class="clubs" v-if="teamsDisplayed(props.item.id)">
              <div class="club-container" v-for="team in props.item.teams" :key="team.id">
                <div class="club-logo-container" :class="team.isPrimary ? 'primary-club' : ''">
                  <img class="club-logo-img" v-if="!team.clubLogoUrl" src="../../../static/icons/team-icon-256x256-darkblue.png"/>
                  <img class="club-logo-img" v-if="team.clubLogoUrl" :src="team.clubLogoUrl"/>
                </div>
                <p class="club-name" :class="team.isPrimary ? 'primary-club' : ''">{{ team.name.toUpperCase() }}</p>
              </div>
            </div>
          </div>
        </td>

        <!-- VIEWS -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.hitCount }}</td>

        <!-- LIKES -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.likeCount }}</td>

        <!-- COMMENTS -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.commentCount }}</td>

        <!-- BUTTONS -->
        <td>
          <v-layout>
            <td class="buttons" :class="$vuetify.breakpoint.name">
              <v-icon class="button mr-1 edit-button" title="Edit" @click="edit(props.index)">mdi-pencil</v-icon>
              <ProxyDeleteButton class="button" @click="del(props.item)"></ProxyDeleteButton>
            </td>
          </v-layout>
        </td>

      </template>
    </v-data-table>
  </div>

</template>

<script>

import ProxyDeleteButton from '../common/ProxyDeleteButton.vue'
import ExternalId from '../tables/ExternalId.vue'

export default {
  name: 'Table',
  components: {
    ProxyDeleteButton,
    ExternalId
  },
  props: [
    'headers',
    'items',
    'pagination',
    'paginationOptions',
    'totalItems',
    'loading'
  ],
  data () {
    return {
      clubHovers: {},
      teamHovers: {}
    }
  },
  methods: {
    getSportName (sportid) {
      return this.$store.getters.sportValues.find(sport => sport.id === sportid).labels.default
    },

    displaySportNames (sportIDs) {
      if (!sportIDs) return

      if (sportIDs.length < 3) {
        return sportIDs.map(sportID => this.getSportName(sportID)).join(', ')
      }

      return `${sportIDs.length} selected`
    },
    formatDate (date) {
      return new Date(date).toLocaleString(`${this.$localeRegion}-${this.$country}`)
    },

    edit (index) {
      this.$emit('edit', index)
    },

    del (item) {
      this.$emit('del', item)
    },

    clubHover (id) {
      this.$set(this.clubHovers, id, true)
    },
    clubBlur (id) {
      this.$delete(this.clubHovers, id)
    },
    clubsDisplayed (id) {
      return this.clubHovers[id] || false
    },

    teamHover (id) {
      this.$set(this.teamHovers, id, true)
    },
    teamBlur (id) {
      this.$delete(this.teamHovers, id)
    },
    teamsDisplayed (id) {
      return this.teamHovers[id] || false
    }
  },
  computed: {
    pagination_: {
      get () {
        return this.pagination
      },
      set (v) {
        window.scrollTo(0, 0)
        this.$emit('paginationUpdate', v)
      }
    }
  }
}

</script>

<style lang="scss" scoped>

td {
  &.xs {
    font-size: 11px !important;
    padding: 0 6px !important;
  }
}

.wide-column {
  min-width: 200px;
}

.clubs-container {
  position: relative;
}

.club-count {
  width: fit-content;
  padding: 4px 12px;
  cursor: pointer;
  background-color: #f5f5f5;
}

.clubs {
  position: absolute;
  bottom: 0;
  left: -240px;
  width: 240px;
  background-color: white;
  border: 1px solid grey;
  padding: 0 6px;
}

.club-container {
  margin: 6px 0;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 12px;
}

.club-logo-container {
  align-self: center;
  width: 24px;
  height: 24px;
  border: 1px solid #cccccc;
  border-radius: 50%;
  display: grid;
  &.primary-club {
    border: 1px solid black;
  }
}

.club-logo-img {
  max-width: 15px;
  max-height: 15px;
  justify-self: center;
  align-self: center;
}

.club-name {
  align-self: center;
  font-size: 12px;
  margin-bottom: 0;
  &.primary-club {
    font-weight: bold;
  }
}

.buttons {
  width: 72px;
  padding: 0 !important;
  align-content: center;
}

.edit-button {
  margin-bottom: -1px;
}

</style>



// WEBPACK FOOTER //
// src/components/clips/Table.vue